import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ColorsTable from "../../../components/Common/ColorsTable"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  UncontrolledTooltip,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import DeleteModel from "common/deleteModel/deleteModel"
import toast, { Toaster } from "react-hot-toast"
import { decryptData, encryptData } from "middleware/encryption"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"

function ColorTable() {
  // document.title = `Colors | ${localStorage.getItem("ShopName")}`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()

  const navigate = useNavigate()

  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [colorId, setColorId] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)

  // filter data for color
  const filterData = textFilter => {
    setSearchText(textFilter == undefined ? '' : textFilter)
  }

  // color list api
  const colorApi = () => {
    setIsLoading(true)
    getApi("color/list", searchText).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
        setTotalRecords(data.length)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  // color list api useEffect
  useEffect(() => {
    colorApi()
  }, [searchText])

  // Delete color handler
  const handleDelete = colorId => {
    if (colorId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this color permanently? ",
      }).then(response => {
        if (response == true) {
          deleteApi(`Color/delete?id=${colorId}`).then(
            async ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== colorId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Sucessfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Color",
                  text: data,
                })
              }
            }
          )
        }
      })
    }
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Update color handler
  const handleEditColor = colordata => {
    if (colordata) {
      setColorId(colordata.Id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(colordata)
    }
  }

  // Create color handler
  const handleColorClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Colors Validations
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: isEdit ? editData.Name : "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The name is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        isEdit
          ? putApi("color/update", {
            id: colorId,
            name: values.Name,
          }).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status == 400) {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.success("Sucessfully updated", {
                style: {
                  fontSize: "15px",
                },
              })
              toggle()
              colorApi()
              validation.handleReset()
            }
          })
          : postApi("color/create", {
            name: values.Name,
          }).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status == 400) {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.success("Sucessfully created", {
                style: {
                  fontSize: "15px",
                },
              })
              toggle()
              colorApi()
              validation.handleReset()
            }
          })
      }
    },
  })

  // popup box handler
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  const handleCodeChange = e => {
    validation.setFieldTouched("Code", true)
    validation.validateForm()
  }

  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Color",
        accessor: "Name",
      },

      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "7%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li>
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditColor(row.original)}
                ></i>
                <UncontrolledTooltip
                  placement="top"
                  autohide={true}
                  target={`edittooltip${row.original.Id}`}
                >
                  Edit
                </UncontrolledTooltip>
              </li>

              <li>
                <i
                  className="fs-6 fas fa-trash-alt btn-delete"
                  id={`deletetooltip${row.original.Id}`}
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <UncontrolledTooltip
                  placement="top"
                  autohide={true}
                  target={`deletetooltip${row.original.Id}`}
                >
                  Delete
                </UncontrolledTooltip>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <ColorsTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isColorList={true}
              handleColorClick={handleColorClick}
              customPageSize={10}
              className="custom-header-css"
              filterData={filterData}
              isLoading={isLoading}
              TotalRecords={totalRecords}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: "350px" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Color" : "Create Color"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <FormGroup className="mb-2">
                      <Label htmlFor="validationCustom03" className="required">
                        Name
                      </Label>
                      <Input
                        name="Name"
                        placeholder="Color Name"
                        type="text"
                        className="form-control-sm"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Name || ""}
                        invalid={
                          validation.touched.Name && validation.errors.Name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.Name && validation.errors.Name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.Name}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>

                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      {formSumitLoading ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                        >
                          <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>{" "}
                          Loading
                        </button>
                      ) : (
                        <Button
                          color="primary"
                          className="btn btn-primary btn-sm "
                          type="submit"
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
ColorTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onFilterChange: PropTypes.func,
}

export default ColorTable
